export const regex = {
  // prettier-ignore
  /* eslint-disable */
  REGEX_NAME: new RegExp('^[a-zA-Z àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ\s\-]{1,32}$'),
  REGEX_POSTALCODE: new RegExp('\\d{5}'),
  REGEX_EMAIL: new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$'),
  REGEX_PHONE: new RegExp('0[6-7][0-9]{8}'),
  REGEX_DATE: new RegExp('^[0-9]{1,2}/[0-9]{1,2}/[0-9]{4}$'),
}
